(function () {
  'use strict';

  var modal = document.getElementById('laki-login-modal');
  var backdrop = document.getElementById('laki-login-backdrop');
  if (!modal) return;

  var modalOpener = null;

  function openModal() {
    modalOpener = document.activeElement;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    if (backdrop) backdrop.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    window.theme?.trapFocus(modal);
    var firstFocusable = modal.querySelector('input, button, [tabindex="0"]');
    if (firstFocusable) firstFocusable.focus({ preventScroll: true });
    document.addEventListener('keydown', onKeyDown);
  }

  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    if (backdrop) backdrop.classList.remove('is-open');
    document.body.style.overflow = '';
    window.theme?.releaseFocus(modal);
    document.removeEventListener('keydown', onKeyDown);
    if (modalOpener?.isConnected) modalOpener.focus({ preventScroll: true });
    modalOpener = null;
  }

  function onKeyDown(e) {
    if (e.key === 'Escape' || e.keyCode === 27) closeModal();
  }

  /* Close on backdrop click */
  if (backdrop) {
    backdrop.addEventListener('click', closeModal);
  }

  /* Close button */
  var closeBtn = modal.querySelector('[data-llm-close]');
  if (closeBtn) closeBtn.addEventListener('click', closeModal);

  /* Desktop — intercept the signed-out trigger inside shopify-account */
  function attachDesktopTrigger() {
    var host = document.querySelector('shopify-account.site-header__account');
    if (!host) return;
    var slot = host.querySelector('[slot="signed-out-avatar"]');
    if (!slot) return;
    slot.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      openModal();
    });
    slot.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        openModal();
      }
    });
  }

  /* Mobile — intercept the account icon link */
  function attachMobileTrigger() {
    var link = document.querySelector('[data-llm-account-mobile]');
    if (!link) return;
    link.addEventListener('click', function (e) {
      e.preventDefault();
      openModal();
    });
  }

  attachDesktopTrigger();
  attachMobileTrigger();
}());

/* ── Signed-in desktop trigger ────────────────────────────────────────────
   shopify-account's own popover is driven by a plain Online Store nav
   menu, which can only hold ordinary links — it has no way to represent
   Orders, Order status, or Profile, since those are pages that only exist
   inside Shopify's hosted /account experience, not linkable destinations
   on their own. So instead of opening that limited popover, send signed-in
   shoppers straight into /account, where Shopify's own navigation (Orders,
   Order status, Profile, Sign out) is already built in.
   Independent of the login-modal IIFE above (and its `if (!modal) return`
   guard) since this has nothing to do with the login modal. ── */
(function () {
  'use strict';
  var trigger = document.querySelector('shopify-account.site-header__account [slot="signed-in-avatar"]');
  if (!trigger) return;
  var url = trigger.dataset.signedInAccountUrl;
  if (!url) return;

  trigger.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    window.location.href = url;
  });
  trigger.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      window.location.href = url;
    }
  });
}());
